/* MonRoi Private Sale: independent 96-hour cycle in each visitor browser. */
(function () {
  'use strict';
  if (window.mktkPrivateSaleTimerLoaded) return;
  window.mktkPrivateSaleTimerLoaded = true;
  var key = 'mktk_private_sale_2026_10_15_deadline';
  var duration = 96 * 60 * 60 * 1000;
  var deadline;
  function read() { try { return Number(window.localStorage.getItem(key)); } catch (e) { return 0; } }
  function persist(value) { try { window.localStorage.setItem(key, String(value)); } catch (e) { /* Storage may be disabled. Keep the page timer working. */ } }
  function nextDeadline(value, now) {
    if (!Number.isFinite(value) || value <= 0 || value > now + duration) return now + duration;
    if (value <= now) return value + (Math.floor((now - value) / duration) + 1) * duration;
    return value;
  }
  function tick() {
    var timers = document.querySelectorAll('[data-mktk-sale-timer]');
    if (!timers.length) return;
    var now = Date.now();
    if (!deadline) deadline = read();
    var renewed = nextDeadline(deadline, now);
    if (renewed !== deadline) { deadline = renewed; persist(deadline); }
    var seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
    var values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
    timers.forEach(function (timer) {
      Object.keys(values).forEach(function (part) {
        var node = timer.querySelector('[data-' + part + ']');
        if (node) node.textContent = String(values[part]).padStart(2, '0');
      });
      timer.hidden = false;
      timer.setAttribute('data-deadline', String(deadline));
    });
  }
  window.addEventListener('storage', function (event) { if (event.key === key) { deadline = read(); tick(); } });
  document.addEventListener('visibilitychange', tick);
  document.addEventListener('shopify:section:load', tick);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  window.setInterval(tick, 1000);
})();
